import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=0c96eb6e&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=0c96eb6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96eb6e",
  null
  
)

export default component.exports